import VueRouter from 'vue-router';

import Main from './components/Main.vue';
import Register from './components/Register.vue';
import Login from './components/Login.vue';
import VerifyCode from './components/VerifyCode.vue';
import ResetCode from './components/ResetCode.vue';

export default new VueRouter({
  routes: [{
      path: '/',
      redirect: '/register',
      component: Main,
      children: [{
          path: 'register',
          component: Register
        },
        {
          path: 'login',
          component: Login
        }
      ]
    },
    {
      path: '/confirm/:code',
      component: VerifyCode
    },
    {
      path: '/reset/:code',
      component: ResetCode
    }
  ]
});
